import { Component } from '@angular/core';

@Component({
  selector: 'inlite-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {

}
